import * as React from 'react';
import { NewCarousel } from '@atomic/atm.carousel/new-carousel.components';
import { MediaQueryContext } from '@atomic/obj.media-query';
import { TestimonyCard } from './testimony-card.component';
export var TestimonyCarousel = function (props) {
    var id = props.id, title = props.title, testimonies = props.testimonies;
    var isMediumOrLarger = React.useContext(MediaQueryContext).isMediumOrLarger;
    return (React.createElement(NewCarousel, { id: id, title: title, loop: true, auto: isMediumOrLarger, duration: 600, interval: 7000 }, testimonies.map(function (testimony, index) { return (React.createElement(TestimonyCard, { key: index, testimony: testimony })); })));
};
